import Index from "..";

export default function IndexHR() {
  return <Index />;
}
